var React = require('react');

function Be (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"fill":"#ED2939","width":"450","height":"390","key":0}),React.createElement("rect",{"fill":"#FAE042","width":"300","height":"390","key":1}),React.createElement("rect",{"width":"150","height":"390","key":2})]);
}

Be.defaultProps = {"viewBox":"0 0 450 390"};

module.exports = Be;

Be.default = Be;
